import React from 'react';
import { ScrollView } from '@gluestack-ui/themed';
import { SafeAreaView } from './SafeAreaView';

const padding = 2 * 8;
const webSidebarWidth = 72;

const ScrollableScreenContainer = ({
  children, testID, scrollRef, refreshControl, bg, ...props
}) => (
  <SafeAreaView
    flex={1}
    w="100%"
    h="100%"
    pt={28}
    alignSelf="center"
    bg={bg || 'transparent'}
  >
    <ScrollView
      $xl-width={1280 - padding - webSidebarWidth}
      $lg-width={992 - padding - webSidebarWidth}
      $md-width={768 - padding - webSidebarWidth}
      $base-width="100%" // full, only x-padding // has no sidebar
      $md-px={0}
      $base-px={20}
      alignSelf="center"
      ref={scrollRef}
      testID={testID}
      refreshControl={refreshControl}
      {...props}
    >
      {children}
    </ScrollView>
  </SafeAreaView>

);

export default ScrollableScreenContainer;
